import { Paragraph } from '@zillow/constellation-10';
import { useContext } from 'react';
import { useExpiredRenterProfileDataQuery } from '../../../../types/GraphqlTypes';
import { InboxPageContext } from '../../../../contexts/InboxPageContextProvider';
import InboxSidebarSection from '../InboxSidebarSection';

export const EXPIRED_RENTER_PROFILE = 'Renter profiles expire after 90 days of no communication.';

const ExpiredRenterProfile = (): JSX.Element | null => {
  const { conversationId, listingAlias } = useContext(InboxPageContext);
  const { data: renterProfileData } = useExpiredRenterProfileDataQuery({
    variables: {
      conversationId: conversationId!,
      listingAlias: listingAlias!,
    },
    fetchPolicy: 'cache-only',
  });

  return renterProfileData?.ZRM_getConversationById.renterProfile?.isRenterProfileHidden ? (
    <InboxSidebarSection title="Renter Profile" shouldShowExpiredStatusLabel>
      <Paragraph textStyle="body-sm">{EXPIRED_RENTER_PROFILE}</Paragraph>
    </InboxSidebarSection>
  ) : null;
};

export default ExpiredRenterProfile;
